import SwipeAction from './SwipeAction';

export type { SwipeActionProps, SwipeActionCssVars } from './SwipeAction';

export default SwipeAction;
